import React from 'react';
import styled from 'styled-components';
import { BlockBox } from './BlockBox';
import { BlockLink } from '@dealstack/frontend/shared/lib/BlockTable/BlockLink/BlockLink.tsx';
import { calculateLinkStates } from '@dealstack/frontend/shared/lib/BlockTable/BlockEntityCell/BlockEntities.utils.ts';
import { BlockSummary } from '@dealstack/frontend/shared/lib/BlockTable/BlockEntityCell/BlockSummary.tsx';
import { BlockEntitiesRowProps } from './BlockEntities.types';

const RowContainer = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	box-sizing: border-box;
	height: 100%;
`;

const LinkContainer = styled.div`
	flex-grow: 1;
	flex-basis: 0;
	display: flex;
	align-items: center;
`;

export const BlockEntitiesRow: React.FC<BlockEntitiesRowProps> = ({
	transactionType,
	fromEntityId,
	toEntityId,
	fromEntityName,
	toEntityName,
	issuerEntityId,
	mainEntityId,
	blocks,
	entityColorMap,
	date,
	units,
	fromBlocksHeld,
	toBlocksHeld,
	fromCost,
	toCost,
	transactionCost,
	currency,
	securityIssuedIn,
	securityUnitDenominator,
}) => {
	const { link1, link2 } = calculateLinkStates({
		transactionType,
		fromEntityId,
		fromEntityName,
		toEntityId,
		toEntityName,
		issuerEntityId,
		mainEntityId,
		entityColorMap,
		fromBlocksHeld,
		toBlocksHeld,
		securityIssuedIn,
		currency,
		fromCost,
		toCost,
		securityUnitDenominator,
	});

	return (
		<RowContainer>
			<BlockSummary
				transactionType={transactionType}
				date={date}
				units={units}
				transactionCost={transactionCost}
				securityIssuedIn={securityIssuedIn}
				currency={currency}
				securityUnitDenominator={securityUnitDenominator}
				width="25%"
			/>
			<LinkContainer>
				<BlockLink
					sourceColor={link1.sourceColor}
					destinationColor={link1.destinationColor}
					lineColor={link1.lineColor}
					hasArrowLeft={link1.hasArrowLeft}
					hasNodeLeft={link1.hasNodeLeft}
					hasArrowRight={link1.hasArrowRight}
					hasNodeRight={link1.hasNodeRight}
					hidden={link1.hidden}
					nodeLeftContextMenuHeader={link1.nodeLeftName}
					nodeRightContextMenuHeader={link1.nodeRightName}
					nodeLeftContextMenuItems={link1.nodeLeftContextMenuItems}
					nodeRightContextMenuItems={link1.nodeRightContextMenuItems}
				>
					{link1.showBox && blocks?.length > 0 ? (
						<BlockBox
							blocks={blocks}
							color={link1.blockColor}
							unitDenominator={securityUnitDenominator}
						/>
					) : null}
				</BlockLink>
			</LinkContainer>

			<LinkContainer>
				<BlockLink
					sourceColor={link2.sourceColor}
					destinationColor={link2.destinationColor}
					lineColor={link2.lineColor}
					hasArrowLeft={link2.hasArrowLeft}
					hasNodeLeft={link2.hasNodeLeft}
					hasArrowRight={link2.hasArrowRight}
					hasNodeRight={link2.hasNodeRight}
					hidden={link2.hidden}
					label={link2.label}
					isMiddle={true}
					nodeLeftContextMenuHeader={link2.nodeLeftName}
					nodeRightContextMenuHeader={link2.nodeRightName}
					nodeLeftContextMenuItems={link2.nodeLeftContextMenuItems}
					nodeRightContextMenuItems={link2.nodeRightContextMenuItems}
				>
					{link2.showBox && blocks?.length > 0 ? (
						<BlockBox
							blocks={blocks}
							color={link2.lineColor}
							unitDenominator={securityUnitDenominator}
						/>
					) : null}
				</BlockLink>
			</LinkContainer>
			<LinkContainer></LinkContainer>
		</RowContainer>
	);
};
